import React from 'react';
import { ArrowUpIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, SALES_EMAIL } from '../data/homepage';
export function ClosingSection() {
  return <section aria-labelledby="closing-title" className="bg-paper" data-id="element-29" data-mp="12slp61xee147">
      <div className="mx-auto flex max-w-[1280px] flex-col gap-8 px-5 py-12 md:px-8 md:py-16 lg:flex-row lg:items-end lg:justify-between lg:gap-16 lg:py-20" data-id="element-30" data-mp="12qr2ai2kfyxh">
        <div data-id="element-31" data-mp="1cpzsr0y82vf3">
          <h2 id="closing-title" className="max-w-[640px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-32" data-mp="1cpgkkbydjle9">
            Tell us what you want to improve.
          </h2>
          <p className="mt-4 max-w-[560px] text-[17px] leading-[1.6] text-ink/80" data-id="element-33" data-mp="1llfr9v9x9yr0">
            Let&rsquo;s put the right people, marketing, and technology behind it.
          </p>
          <ul className="mt-6 flex flex-col gap-x-8 gap-y-1 sm:flex-row sm:flex-wrap" data-id="element-34" data-mp="1vi0wohputbvd">
            <li data-id="element-35" data-mp="1qjr14607w998">
              <a href={PHONE_HREF} className="inline-flex min-h-[44px] items-center gap-2.5 text-[16px] font-bold text-ink underline-offset-4 hover:underline" data-id="element-36" data-mp="1qk989xof47vx">
                <PhoneIcon className="h-5 w-5 text-brand-greenDeep" aria-hidden data-id="element-37" data-mp="27djfwqj3649s" />
                {PHONE_DISPLAY}
              </a>
            </li>
            <li data-id="element-38" data-mp="2gcn2w5ldj3tk">
              <a href={`mailto:${SALES_EMAIL}`} className="inline-flex min-h-[44px] items-center gap-2.5 break-all text-[16px] font-bold text-ink underline-offset-4 hover:underline" data-id="element-39" data-mp="2gd6mdqqoa09p">
                <MailIcon className="h-5 w-5 shrink-0 text-brand-greenDeep" aria-hidden data-id="element-40" data-mp="2q8880clqok7j" />
                {SALES_EMAIL}
              </a>
            </li>
          </ul>
        </div>
        <a href="#contact" className="group inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md bg-brand-orange px-7 py-4 text-[17px] font-bold text-ink transition-colors duration-150 ease-out hover:bg-brand-orangeHover lg:self-end" data-id="element-41" data-mp="2zzkzv47jfadk">
          Let&rsquo;s build your plan
          <ArrowUpIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5" aria-hidden data-id="element-42" data-mp="18w6uwpbwubwc" />
        </a>
      </div>
    </section>;
}